<template>
  <component
    :is="type"
    v-bind="$attrs"
    class="item-preview-card"
    :class="{ decorated }"
    v-on="$listeners"
  >
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "ItemPreviewCard",
  props: {
    decorated: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "div"
    }
  }
};
</script>

<style scoped>
.item-preview-card {
  @apply mb-auto leading-none;
  transition: all 150ms ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  &:focus {
    @apply outline-none;
  }
}

.decorated {
  @apply border border-grey-lighter border-solid p-1 rounded-lg shadow;

  @screen md {
    @apply p-2;
  }

  @screen xl {
    @apply p-3;
  }
}

img {
  @apply rounded-lg p-1 w-full;
  background-color: #f0f0f0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='13' viewBox='0 0 8 8'%3E%3Cg fill='%239C92AC' fill-opacity='0.4'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E");

  @screen lg {
    @apply p-2;
  }

  @screen xl {
    @apply p-3;
  }
}
</style>
